import React from 'react';
import InputValidation from '../InputValidation.js';
import CheckboxOrRadioGroupContext from './CheckboxOrRadioGroupContext.js';
import { jsx } from 'react/jsx-runtime';

const CheckboxOrRadioGroupValidation = ({
  children,
  variant
}) => {
  const {
    validationMessageId = ''
  } = React.useContext(CheckboxOrRadioGroupContext);
  return /*#__PURE__*/jsx(InputValidation, {
    validationStatus: variant,
    id: validationMessageId,
    children: children
  });
};
CheckboxOrRadioGroupValidation.displayName = "CheckboxOrRadioGroupValidation";
CheckboxOrRadioGroupValidation.__SLOT__ = Symbol('CheckboxOrRadioGroupValidation');

export { CheckboxOrRadioGroupValidation as default };
